const BetErrorsIndexes = {
    title: 'Example JSON for betErrorsIndexes parameter',
    initialDisplayedCode: `{
        "selectedOutcomes":[{
            "id": 1234,
            "odds": 1900,
            "startingPrice": false
        }, {
            "id": 45678,
            "odds": 2000
        }],
        "betErrorsIndexes":[0,1],
        "translations":{
            "startingPrice":"SP",
            "totalOddsNotAvailable":"N/A"
        }
    }`,
};

export default BetErrorsIndexes;
